module.exports = __webpack_public_path__ + "static/img/logo6.c4079e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo6.png
// module id = UN16
// module chunks = 0